import { useEffect, useState } from 'react';
export var STICK_MOTION_STATUS;
(function (STICK_MOTION_STATUS) {
  STICK_MOTION_STATUS["DEFAULT"] = "dsapg_scroll_default";
  STICK_MOTION_STATUS["SCROLL_UP"] = "dsapg_scroll_up";
  STICK_MOTION_STATUS["SCROLL_DOWN"] = "dsapg_scroll_down";
})(STICK_MOTION_STATUS || (STICK_MOTION_STATUS = {}));
export const useScrolling = offset => {
  const [isScrolling, setIsScrolling] = useState(STICK_MOTION_STATUS.DEFAULT);
  useEffect(() => {
    let oldYPosition = window.pageYOffset;
    const handleScroll = () => {
      const currentYPosition = window.pageYOffset;
      const isScrolled = oldYPosition > currentYPosition;
      if (offset && currentYPosition <= offset && isScrolling !== STICK_MOTION_STATUS.SCROLL_UP || currentYPosition === 0) {
        return setIsScrolling(STICK_MOTION_STATUS.DEFAULT);
      }
      setIsScrolling(isScrolled ? STICK_MOTION_STATUS.SCROLL_UP : STICK_MOTION_STATUS.SCROLL_DOWN);
      oldYPosition = currentYPosition;
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolling, offset]);
  return isScrolling;
};